import type NumberUnit from '@exodus/currency';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import getFeeAssetHasEnoughBalanceSelector from '@/ui/flux/balances/selectors/fee-asset-has-enough-balance';

type UseIsFeeAssetEnoughParams = {
  assetName: string;
  walletAccount: string;
  fees: { fee: NumberUnit };
};

function useIsFeeAssetEnough({
  assetName,
  walletAccount,
  fees,
}: UseIsFeeAssetEnoughParams) {
  const getFeeAssetHasEnoughBalance = useSelector(
    getFeeAssetHasEnoughBalanceSelector,
  );

  return useMemo(
    () =>
      getFeeAssetHasEnoughBalance({
        assetName,
        walletAccount,
        fees,
      }),
    [assetName, fees, getFeeAssetHasEnoughBalance, walletAccount],
  );
}

export default useIsFeeAssetEnough;
